import React, { useState } from 'react';
import { ContainerSection } from '../../../../../../../components/NovoSistema/ContainerSection';
import InputDate from '../../../../../../../components/NovoSistema/InputDate';
import InputText from '../../../../../../../components/NovoSistema/InputText';
import InputCheckBox from '../../../../../../../components/NovoSistema/InputCheckBox';
import SelectAndOptions from '../../../../../../../components/NovoSistema/SelectAndOptions';
import ButtonsGeneric from '../../../../../../../components/NovoSistema/ButtonsGeneric';
import { WrapperInputsNewSystem } from '../../../../../../../components/NovoSistema/WrapperInputsNewSystem';
import { WrapperLegendItens } from '../../../../../../../components/NovoSistema/WrapperLegendItens';
import HeaderButtons from '../../../../../../../components/NovoSistema/HeaderButtons';
import ButtonOptions from '../../../../../../../components/NovoSistema/ButtonOptions';
import DoubleInput from '../../../../../../../components/NovoSistema/DoubleInput';

export default function EntradaAdd({ setOption }) {
  const [internalOption, setInternalOption] = useState('Principal');
  return (
    <div>
      <HeaderButtons>
        <ButtonOptions
          buttonName="Principal"
          border="#333F50"
          active={internalOption === 'Principal' ? true : false}
          yourFunction={() => setInternalOption('Principal')}
        />
        <ButtonOptions
          buttonName="Itens"
          border="#333F50"
          active={internalOption === 'Itens' ? true : false}
          yourFunction={() => setInternalOption('Itens')}
          disabled={true}
        />
        <ButtonOptions
          buttonName="Transportadora/Volumes"
          border="#333F50"
          active={internalOption === 'Transportadora/Volumes' ? true : false}
          yourFunction={() => setInternalOption('Transportadora/Volumes')}
        />
        <ButtonOptions
          buttonName="Importar Pedido de Compra"
          border="#333F50"
          active={internalOption === 'Importar Pedido de Compra' ? true : false}
          yourFunction={() => setInternalOption('Importar Pedido de Compra')}
          disabled={true}
        />
        <ButtonOptions
          buttonName="Vencimento"
          border="#333F50"
          active={internalOption === 'Vencimento' ? true : false}
          yourFunction={() => setInternalOption('Vencimento')}
        />
        <ButtonOptions
          buttonName="Observações"
          border="#333F50"
          active={internalOption === 'Observações' ? true : false}
          yourFunction={() => setInternalOption('Observações')}
        />
      </HeaderButtons>
      {internalOption === 'Principal' && (
        <div>
          <ContainerSection>
            <h3>Dados do Documento</h3>
            <div>
              <WrapperInputsNewSystem>
                <SelectAndOptions
                  title="* Emitida por"
                  id="EmitidaPor"
                  optionsArray={['', 'Matriz/Filial', 'Terceiros']}
                  widthPercentage="30%"
                />
                <InputDate title="Data de Emissão" id="DataDeEmissao" widthPercentage="30%" />
                <InputDate title="Data de Entrada" id="DatadeEntrada" widthPercentage="30%" />
              </WrapperInputsNewSystem>
              <WrapperInputsNewSystem>
                <DoubleInput
                  title="* Parceiro de Negócios/Empresa"
                  id=" ParceiroDeNegociosEmpresa"
                  widthPercentage="100%"
                />
              </WrapperInputsNewSystem>
              <WrapperInputsNewSystem>
                <InputText title="Município" id="Municipio" widthPercentage="40%" />
                <InputText title="UF" id="UF" widthPercentage="40%" />
              </WrapperInputsNewSystem>
              <WrapperInputsNewSystem>
                <SelectAndOptions
                  title="* Documento Fiscal"
                  id="DocumentoFiscal"
                  optionsArray={[
                    '',
                    '1  | NF    | Nota Fiscal',
                    '1B | NFA   | Nota Fiscal Avulsa',
                    '2  | NFVC  | Nota Fiscal Venda Consumidor',
                    '2D | CFECF | Cupom Fiscal - ECF',
                    '4  | NFP   | Nota Fiscal Produtor',
                    '55 | NFE   | Nota Fiscal Eletrônica',
                    '57 | CTE   | Conhecimento de Transporte Eletrônico',
                    '59 | CFE   | Cupom Fiscal Eletrônico - SAT',
                    '65 | NFCE  | Nota Fiscal Eletrônica ao Consumidor Final - NFC-e',
                    '100 | NFS  | Nota Fiscal Serviço',
                    '101 | NFFS | Nota Fiscal Fatura de Serviços',
                    '104 | M01F | Nota Fiscal Fatura (Modelo 1)',
                    '106 | RS | Recibo de Serviço',
                  ]}
                  widthPercentage="40%"
                />
                <InputText title="* Nº Docto" id="NDocto" widthPercentage="20%" />
                <InputText title="* Série" id="Serie" widthPercentage="20%" />
              </WrapperInputsNewSystem>
              <WrapperInputsNewSystem>
                <InputText title="* Chave de Acesso" id="Chave de Acesso" widthPercentage="40%" disabled={true} />
                <InputText title="Operação Fiscal" id="OperacaoFiscal" widthPercentage="20%" disabled={true} />
                <InputCheckBox title="Habilitar Rateio" id="HabilitarRateio" />
              </WrapperInputsNewSystem>
            </div>
          </ContainerSection>
        </div>
      )}
      {internalOption === 'Transportadora/Volumes' && (
        <div>
          <ContainerSection>
            <h3>Transportadora</h3>
            <div>
              <WrapperInputsNewSystem>
                <DoubleInput title="Transportadora" id="Transportadora" widthPercentage="100%" />
              </WrapperInputsNewSystem>
              <WrapperInputsNewSystem>
                <SelectAndOptions
                  title="Tipo Entrega"
                  id="TipoEntrega"
                  optionsArray={[
                    '',
                    '0 - Contratação do Frete por conta do remetente (CIF)',
                    '1 - Contratação do Frete por conta do Destinatário (FOB)',
                    '2 - Contratação do Frete por conta de Terceiros',
                    '3 - Transporte Próprio por conta do Remetente',
                    '4 - Transporte Próprio por conta do Destinatário',
                    '9 - Sem ocorrência de Transporte',
                  ]}
                  widthPercentage="40%"
                />
                <InputText title="Placa" id="Placa" widthPercentage="20%" />
                <SelectAndOptions
                  title="UF da Placa"
                  id="UFDaPlaca"
                  optionsArray={[
                    '',
                    'AC',
                    'AL',
                    'AP',
                    'AM',
                    'BA',
                    'CE',
                    'DF',
                    'ES',
                    'GO',
                    'MA',
                    'MT',
                    'MS',
                    'MG',
                    'PA',
                    'PB',
                    'PR',
                    'PE',
                    'PI',
                    'RJ',
                    'RN',
                    'RS',
                    'RO',
                    'RR',
                    'SC',
                    'SP',
                    'SE',
                    'TO',
                  ]}
                  widthPercentage="20%"
                />
              </WrapperInputsNewSystem>
            </div>
          </ContainerSection>
          <ContainerSection>
            <h3>Volumes</h3>
            <div>
              <WrapperInputsNewSystem>
                <InputText title="Quantidade" id="Quantidade" widthPercentage="30%" />
                <InputText title="Espécie" id="Especie" widthPercentage="30%" />
                <InputText title="Marca" id="Marca" widthPercentage="30%" />
              </WrapperInputsNewSystem>
              <WrapperInputsNewSystem>
                <InputText title="Numeração" id="Numeracao" widthPercentage="30%" />
                <InputText title="Peso Bruto" id="PesoBruto" widthPercentage="30%" />
                <InputText title="Peso Líquido" id="PesoLiquido" widthPercentage="30%" />
              </WrapperInputsNewSystem>
            </div>
          </ContainerSection>
        </div>
      )}
      {internalOption === 'Vencimento' && (
        <div>
          <ContainerSection>
            <h3>Dados Vencimento</h3>
            <div>
              <WrapperInputsNewSystem>
                <InputCheckBox title="Gerar Contas a Pagar" id="GerarContasAPagar" />
              </WrapperInputsNewSystem>
              <WrapperInputsNewSystem>
                <SelectAndOptions
                  title="Conta Bancária"
                  id="ContaBancaria"
                  optionsArray={['', '999 | 9999 | 9999-9 | Caixinha']}
                  widthPercentage="20%"
                />
                <SelectAndOptions
                  title="Forma de Pagamento"
                  id="FormaDePagamento"
                  optionsArray={[
                    '',
                    'Novo...',
                    'Dinheiro',
                    'Cheque',
                    'Cartão Drédito',
                    'Cartão Débito',
                    'Transferência DOC',
                    'Transferência TED',
                    'Boleto',
                    'Voucher',
                    'Troca',
                    'Conta',
                    'Débito Automático',
                  ]}
                  widthPercentage="20%"
                />
                <InputText title="Qtde. Parcelas" id="QtdeParcelas" widthPercentage="20%" />
                <InputText title="Abatimento" id="Abatimento" widthPercentage="20%" />
              </WrapperInputsNewSystem>
              <WrapperInputsNewSystem>
                <InputText title="Acréscimo" id="Acrescimo" widthPercentage="20%" />
                <SelectAndOptions
                  title="Intervalo"
                  id="Intervalo"
                  optionsArray={[
                    '',
                    'Mensal',
                    'Semanal',
                    'Quinzenal',
                    'Variável (A definir)',
                    'Dia Fixo',
                    '1º dia útil do mês',
                    'Último dia do mês',
                  ]}
                  widthPercentage="20%"
                />
                <InputText title="Dia Fixo" id="DiaFixo" widthPercentage="20%" />
                <InputCheckBox title="À vista" id="Avista" />
                <InputCheckBox title="Com entrada" id="ComEntrada" />
              </WrapperInputsNewSystem>
              <ButtonsGeneric>
                <button className="success">Gerar Parcelas</button>
              </ButtonsGeneric>
            </div>
          </ContainerSection>
          <ContainerSection>
            <h3>Cálculo dos Vencimentos</h3>
            <div></div>
          </ContainerSection>
          <ContainerSection>
            <h3>Anexos - Boletos/Duplicatas</h3>
            <WrapperLegendItens>
              <input type="file" name="attachments" id="attachments" />
            </WrapperLegendItens>
          </ContainerSection>
        </div>
      )}
      {internalOption === 'Observações' && (
        <div>
          <ContainerSection>
            <h3>Observações</h3>
            <div>
              <textarea name="Observation" id="observation" cols="100" rows="3"></textarea>
              <p>Máximo de 500 caracteres.</p>
            </div>
          </ContainerSection>
        </div>
      )}

      <ContainerSection>
        <h3>Totais</h3>
        <div>
          <WrapperInputsNewSystem>
            <InputText title="Total Financeiro" id="TotalFinanceiro" widthPercentage="40%" disabled={true} />
            <InputText title="Total Docto Fiscal" id="TotalDoctoFiscal" widthPercentage="40%" disabled={true} />
          </WrapperInputsNewSystem>
        </div>
      </ContainerSection>
      <ButtonsGeneric>
        <button className="success">Salvar</button>
        <button className="error" onClick={() => setOption('search')}>
          Retornar
        </button>
      </ButtonsGeneric>
      <span> {' * '} Campo de preenchimento Obrigatório</span>
    </div>
  );
}
